import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'inherit',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'column',
    },
  },
  simple: {
    '&:hover': {
      boxShadow: theme.shadows[2],
    },
  },
  complex: {
    '& $text': {
      display: 'none',

      [theme.breakpoints.up('sm')]: {
        display: 'block',
        marginLeft: theme.spacing(2),
        marginTop: 0,
        color: theme.palette.primary.dark,
        position: 'relative',
        bottom: theme.spacing(2),
        maxWidth: 140,
      },
    },
    '& $content': {
      padding: theme.spacing(2.5, 3),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(7, 4, 4, 4),
      },
    },
  },
  action: {
    '&:hover > .MuiCardActionArea-focusHighlight': {
      opacity: 0,
    },
  },
  header: {
    backgroundColor: theme.palette.primary.lighter,
    display: 'flex',
    minWidth: theme.spacing(12.5),
    minHeight: theme.spacing(8),
    justifyContent: 'center',
    alignItems: 'center',

    [theme.breakpoints.up('sm')]: {
      width: '100%',
      alignItems: 'flex-end',
      minHeight: theme.spacing(11),
    },
  },
  iconWrapper: {
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.primary.light,
      borderRadius: '50%',
      position: 'relative',
      top: theme.spacing(1.25),
    },
  },
  icon: {
    width: theme.spacing(4),
    height: 'auto',
    color: theme.palette.primary.dark,
    [theme.breakpoints.up('sm')]: {
      color: theme.palette.primary.lighter,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'flex-start',
    padding: theme.spacing(1.5, 1.5, 1.5, 3),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4, 2),
      alignItems: 'center',
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
    },
  },
  text: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(1),
    },
  },
}))

export default useStyles
